require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-meet-yana-substitute-teacher-turned-web-developer-apprentice.json") })
        }
      }, "path---blog-meet-yana-substitute-teacher-turned-web-developer-apprentice");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-meet-yana-substitute-teacher-turned-web-developer-apprentice!./.cache/json/blog-meet-yana-substitute-teacher-turned-web-developer-apprentice.json
// module id = 997
// module chunks = 231608221292675